import { translate } from "app/filters/i18nFilter";
import type { PrimitiveListCellValue } from "app/pages/sales-intelligence/common-components/table-cells";
import type { ParentCompanyValue } from "app/pages/sales-intelligence/domain/leads/types/company";
import type { LeadCellRecord } from "app/pages/sales-intelligence/modules/leads-search/types/rows";
import {
    createCompanyPageLink,
    createWebsitePageLink,
} from "app/pages/sales-intelligence/sub-modules/account-overview/shared/helpers/routing";
import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import type { LeadsSearchRow } from "../../types";
import { leadRowTypeGuard } from "../../types/type-guards";
import { getLeadDomainFromRow } from "../../utils/rows";

export const createLeadOverviewHref = <RecordType extends LeadCellRecord>(record: RecordType): string => {
    const country = "country" in record ? record.country : undefined;
    const countryParam = country ? { country } : {};
    return leadRowTypeGuard.isCompanyLeadRow(record)
        ? createCompanyPageLink({
              key: getLeadDomainFromRow(record),
              ...countryParam,
              isWWW: "*",
              webSource: "Total",
              areTopLevelDomainsIncluded: leadRowTypeGuard.isCompanyLeadRow(record),
          })
        : createWebsitePageLink({
              key: getLeadDomainFromRow(record),
              ...countryParam,
              isWWW: "*",
              webSource: "Total",
              duration: "3m",
          });
};

export const createParentCompanyLeadCellRecord = (
    parentCompany: ParentCompanyValue,
    record: Pick<LeadsSearchRow, "index" | "country">,
): LeadCellRecord => ({
    index: record.index,
    company: parentCompany.name,
    favicon: getFaviconUrl(parentCompany.domain),
    is_new: false,
    company_domains: [
        {
            domain: parentCompany.domain,
            isMainDomain: true,
            headQuarter: 0,
        },
    ],
    country: record.country,
});

export const formatTechnologiesArray = (value: readonly PrimitiveListCellValue[]): string =>
    translate("si.components.advanced_search_results_table.technologies_cell.label", {
        numberOfTechnologies: value.length,
    });
